// extracted by mini-css-extract-plugin
export default {"wrapper":"sent-request-popup_wrapper__4bKcS","container":"sent-request-popup_container__SHGdp"};